import React from 'react';
import { Bubble, BubbleContentProps } from 'tea-component';
import {
  getAggregationTipContent,
  getDataMapMetricsEnInfo,
} from './utils/aggregation';
// @ts-ignore
import { SOURCE_MAP } from '@/pages/intelligence/pages/SourcesMetrics/components/DataMap/DetailInfo/FixData';
import {
  AMEND_TYPE,
  AMEND_METRIC,
  AMEND_PLATFORM,
  RNKING_DATA_SOURCE,
  RNKING_METRIC,
} from './utils/static_data';
// import './index.less';
import './index.scss';

// props数据类型规范
interface Props {
  placement?: BubbleContentProps['placement']; // 冒泡提示位置
  DomOrText: JSX.Element[] | JSX.Element | string; // 展示的文本
  customBubbleContent?: JSX.Element[] | JSX.Element | string; // 自定义气泡内容
  style?: any; // 文案样式
  type?: 'mobile' | 'pc' | 'console' | 'company' | 'streaming' | string; // 游戏类型
  ratioType?: 0 | 1; // 是否百分比排序
  market?: string; // 指标名称(title)
  platform?: string; // 对应平台/数据源(icon)
  diyClassName?: string;
  hasPointer?: boolean; // 是否要hover手型
  [keyName: string]: any; // 其他参数
}

// props的默认值
index.defaultProps = {
  placement: 'top',
  style: null,
  type: '',
  ratioType: 0,
  market: '',
  platform: '',
  hasPointer: true,
  diyClassName: '',
};

/**
 * 用于展示“表格特定标题/卡片”等的聚合方式提示
 */
function index(props: Props) {
  const {
    placement,
    DomOrText = null,
    customBubbleContent = null,
    style,
    type = '',
    ratioType,
    market = '',
    platform = '',
    hasPointer,
    closeOnScroll = false,
    diyClassName,
  } = props;

  const bubbleContent = () => {
    // 当有自定义显示内容时
    if (customBubbleContent) return customBubbleContent;

    // 当数据源为Ranking中的、或 P.Heat时
    // if ((RNKING_DATA_SOURCE?.includes(platform?.toLowerCase()) && !['PCU', 'ACU'].includes(market)) || (market === 'P.Heat')) {
    //   return getDataMapMetricsEnInfo(
    //     AMEND_TYPE?.[type] || type?.toString(),
    //     RNKING_METRIC?.[market] || market?.toString(),
    //     SOURCE_MAP?.[platform] || platform?.toString(),
    //   );
    // }

    // 气泡内容提示文本
    let _content = getAggregationTipContent(
      /* 参数type */
      AMEND_TYPE[type] || type?.toString(),
      /* 参数market */
      (type === 'pc' || type === 'console') && market === 'MAU'
        ? market.toString()
        : AMEND_METRIC[market] || market?.toString(),
      /* 参数platform */
      type === 'company'
        ? 'Appannie'
        : AMEND_PLATFORM[platform] || platform?.toString(),
    );
    // 百分比排序时不提示任何内容
    let _exist = ratioType === 1 ? '' : _content;

    if (!Boolean(_exist)) return '';
    return (
      <span
        style={{ maxWidth: 818, display: 'block', boxSizing: 'border-box' }}
        dangerouslySetInnerHTML={{ __html: _content }}
      ></span>
    );
  };

  const bubbleContentInfo = bubbleContent();

  return (
    <Bubble
      className={'bubble-all-bg ' + diyClassName}
      arrowPointAtCenter
      dark
      // trigger={'click'}
      placement={placement}
      content={<div className="dbi-bubble-all-text">{bubbleContentInfo}</div>}
      closeOnScroll={closeOnScroll}
    >
      <span
        className={hasPointer && bubbleContentInfo ? 'cursor-pointer' : ''}
        style={style}
      >
        {DomOrText}
      </span>
    </Bubble>
  );
}

export default index;
